import { object, string } from 'yup'

const fourCharCode = string()
  .required()
  .matches(
    /^[A-Za-z0-9]{4}$/,
    'Must be exactly 4 letters or numbers'
  )
  .default('')

export const enableBorderConnectFormSchema = object().shape({
  legalCompanyName: string().required('Legal company name is required').default(''),
  scacCode: fourCharCode,
  carrierCode: fourCharCode,
  companyKey: string().required('Company key is required').default(''),
})
